import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Blank from '../../../hoc/Blank/Blank';
import Input from '../../UI/Input/Input';
import Button from '../../UI/Button/Button';
import Spinner from '../../UI/Spinner/Spinner';
import Modal from '../../UI/Modal/Modal';
import classes from './Auth.css';
import * as actions from '../../../store/actions/index';
import { updateObject, checkValidity } from '../../../shared/utility';
import blank from '../../../hoc/Blank/Blank';
import SignUp from '../SignUp/SignUp';

class Auth extends Component {
    state = {
        controls: {
            phone: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Cell Number'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false
            }
        },
        isSignup: true,
        showModal: false
    }

    componentDidMount () {
    }

    componentWillUpdate () {
        if (this.props.isAuthenticated) {
            this.props.setPage('loads');
        }
    }

    inputChangedHandler = ( event, controlName ) => {
        const updatedControls = updateObject( this.state.controls, {
            [controlName]: updateObject( this.state.controls[controlName], {
                value: event.target.value,
                valid: checkValidity( event.target.value, this.state.controls[controlName].validation ),
                touched: true
            } )
        } );
        this.setState( { controls: updatedControls } );
    }

    submitHandler = ( event ) => {
        event.preventDefault();
        this.props.onAuth( this.state.controls.phone.value, this.state.isSignup );
    }

    signupHandler = ( e ) => {
        e.preventDefault();
        this.props.setPage("signup");
    }


    render () {
        const formElementsArray = [];
        for ( let key in this.state.controls ) {
            formElementsArray.push( {
                id: key,
                config: this.state.controls[key]
            } );
        }

        let form = formElementsArray.map( formElement => (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={( event ) => this.inputChangedHandler( event, formElement.id )} />
        ) );

        if ( this.props.loading ) {
            form = <Spinner />
        }

        let errorMessage = null;

        if ( this.props.error ) {
            errorMessage = (
                <p>{this.props.error.message}</p>
            );
        }

        return (
            <Blank>
            <div className={classes.Auth}>
                {errorMessage}
                <form>
                    {form}
                    <Button btnType="Success" clicked={this.submitHandler}>SUBMIT</Button>
                    <a  onClick={this.signupHandler}>Signup</a>
                </form>
               
            </div>
            </Blank>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: state.orders.loading,
        error: state.orders.errorMessage,
        isAuthenticated: state.orders.token !== null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: ( email, isSignup ) => dispatch( actions.auth( email, isSignup ) )
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Auth );


// WEBPACK FOOTER //
// ./src/components/Security/Auth/Auth.js